import React, { Component, Fragment } from "react";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import {
	Table,
	Card,
	Form,
	Button,
	Row,
	Icon,
	Popconfirm,
	Spin,
	Tooltip,
	Select
} from "antd";
import SimpleSiteList from "components/SimpleSiteList";
import SimplePlatformList from "./components/SimplePlatformList";

import "ag-grid/dist/styles/ag-grid.css";
import "ag-grid/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";

import { locationPrefix } from "common/general";
import { inject, observer } from "mobx-react";
import { ModuleMap, ModuleValue } from "common/modules";

const Option = Select.Option;

var doFollowRenderer = function(params) {
	if (params.node.group == true) {
		return null;
	}
	if (params.value == true) {
		return "<span>Yes</span>";
	} else {
		return "<span>No</span>";
	}
};

var moduleFormatter = function(params) {
	return ModuleMap[params.value];
};

@Form.create({
	onFieldsChange(props, changedFields) {
		props.onFieldsChange(changedFields);
	},
	mapPropsToFields(props) {
		return props.fields;
	}
})
@observer
class SiteSelectionForm extends Component {
	render() {
		return (
			<Form>
				<Form.Item label="Select By">	
					{this.props.form.getFieldDecorator("siteSelectionType", {
										rules: [
											{
												required: true,
												message: "Please select a profile"
											}
										]
					})(
						<Select width={200}>
							<Option value="Condition">Platforms</Option>
							<Option value="Manually">Sites</Option>
						</Select>
					)}				
				</Form.Item>
			</Form>
		)
	}
}

@inject("rootStore")
@observer
export default class SiteSelectionsPage extends Component {	

	onFieldsChange = changedFields => {
		const {
			rootStore: { siteSelectionStore }
		} = this.props;

		siteSelectionStore.formChanged(changedFields);
	};

	mapPropsToFields = () => {
		const {
			rootStore: { siteSelectionStore }
		} = this.props;
		
		const stateForm = siteSelectionStore.stateForm;
		
		return {
			siteSelectionType: Form.createFormField(stateForm.siteSelectionType)			
		};
	};

	createPlatformColumnDefs = () => {
		return [{
			headerName: "Module",
			field: "module",
			filter: 'agSetColumnFilter',
			valueFormatter: moduleFormatter,
			editable: false,
			hide: false,
			rowGroupIndex: 0
		}];
	}

	createSiteColumnDefs = () => {
		return [
			{
				headerName: "Module",
				field: "id.module",
				valueFormatter: moduleFormatter,
				editable: false,
				hide: false,
				rowGroupIndex: 0
			},
			{
				headerName: "Platform",
				field: "platform",
				editable: false,
				hide: false,
				rowGroupIndex: 1
			},
			{
				field: "id",
				headerName: "ID",
				editable: false,
				hide: true
			},
			{
				headerName: "DA",
				field: "pr",
				width: 100,
				editable: false,
				floatCell: true,
				filter: "agNumberColumnFilter",
				filterParams: {
					filterOptions: ["greaterThanOrEqual"],
					cellHeight: 20,
					newRowsAction: "keep"
				}
			},
			{
				headerName: "Dofollow",
				field: "dofollow",
				width: 150,
				editable: false,
				cellRenderer: doFollowRenderer,
				filter: "agSetColumnFilter"
			}
		];
	}

	onRowSelected = event => {
		if (event.node.group == false) {
			event.data.checked = event.node.selected;
		}
	};

	getRowNodeId = (data) => {
		return data.id.module + "_" + data.siteId;
	}

	onGridReady(params) {
		this.gridApi = params.api;
		this.gridColumnApi = params.columnApi;
		
		// this.gridApi.forEachNode(node => {
		// 	if (node.group == false) {
		// 		node.setSelected(node.data.checked, false, false, false);
		// 	}
		// });
	}

	saveSiteSelection = () => {
		const {
			rootStore: { siteSelectionStore }
		} = this.props;

		siteSelectionStore.saveSiteSelection();
	}

	render() {
		const {
			rootStore: {
				siteSelectionStore
			}
		} = this.props;

		const siteSelection = siteSelectionStore.siteSelection;
		const ui = siteSelectionStore.ui;

		let breadcrumbList = [];

		if (!ui.loadingSiteSelection) {
			breadcrumbList = [
				{
					title: "Home",
					href: locationPrefix + "/"
				},
				{
					title: "Site Selections",
					href: locationPrefix + "/site-selections"
				},
				{
					title: siteSelection.name
				}
			];
		}

		let spinning = ui.loadingSiteSelection == true || ui.savingSiteSelection == true;
		
		var sites = siteSelectionStore.sites;
		var platforms = siteSelectionStore.platforms;		
		var stateForm = siteSelectionStore.stateForm;

		// console.log("Is loading site selection: " + ui.loadingSiteSelection);

		return (
			<Fragment>
				{ui.loadingSiteSelection == true ? (
					""
				) : (
					<PageHeaderLayout
						breadcrumbList={breadcrumbList}
						title={siteSelection.name}
					>
						<Card>
						<div
				style={{
					width: "100%",
					height: window.screen.height * 3 / 4 + 100
				}}
			>							
							<Spin spinning={spinning}>
								<div style={{
									boxSizing: "border-box",
									height: (window.screen.height * 3) / 4 - 60,
									width: "100%"}}
								>	
								<Button type="primary" onClick={this.saveSiteSelection}>Save Changes</Button>
								<SiteSelectionForm fields={this.mapPropsToFields()} onFieldsChange={this.onFieldsChange}/>																					
								{stateForm.siteSelectionType.value == "Condition" ? 
									<SimplePlatformList platforms={platforms} columnDefs={this.createPlatformColumnDefs()} /> :
									<SimpleSiteList
										sites={sites}
										columnDefs={this.createSiteColumnDefs()}
									/>
								}
							</div>
							</Spin>
						</div>	
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		)
	}
}